export type Stage = 'copy' | 'canvas'

export const STAGES: readonly Stage[] = ['copy', 'canvas']

export const STAGE_ROUTES = { copy: 'deliverable-copy', canvas: 'deliverable-canvas' } as const satisfies Record<Stage, string>

export const stageOfRoute = (name: unknown) => STAGES.find(stage => STAGE_ROUTES[stage] === name) ?? null

// A template has no copy stage, so it is shown on the canvas whatever the address asks for.
export const resolveStage = (requested: Stage | null, { template, designed }: { template: boolean; designed: boolean }) => {
  if (template) return 'canvas'
  return requested ?? (designed ? 'canvas' : 'copy')
}
